import { render } from "./BaseLinkButton.vue?vue&type=template&id=4ac4b8d6&scoped=true"
import script from "./BaseLinkButton.vue?vue&type=script&lang=js"
export * from "./BaseLinkButton.vue?vue&type=script&lang=js"

import "./BaseLinkButton.vue?vue&type=style&index=0&id=4ac4b8d6&scoped=true&lang=css"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac4b8d6"]])

export default __exports__